export default {
  DragHandleClassName: 'drag-icon-indicator',
  WidgetDisplay: {
    Show: 'SHOW',
    Lock: 'LOCK',
    Hide: 'HIDE',
  },
};
